module.exports = __webpack_public_path__ + "static/media/case_04.d43f53b2.jpg";